import type { Ref } from 'vue'
import LocationProduct from '../../../../../models/LocationProduct'


export function useDayLayout(
  locationProducts: Ref<LocationProduct[]>,
) {

  // import type {
  //   CalendarDaySlotScope,
  //   CalendarEventParsed,
  //   CalendarEventVisual
  // } from 'vuetify/lib/components/VCalendar/types'

  function dayLayoutFn(
    _events: any[], // CalendarEventParsed[],
    _firstWeekday: number,
    _overlapThreshold: number,
  ): Function {

    return (
      _day: any, // CalendarDaySlotScope,
      dayEvents: any[], // CalendarEventParsed[],
      _timed: boolean,
      _reset: boolean,
    ): any[] /* CalendarEventVisual[] */ => {

      const output: any[] = []

      // preparation for summary columns

      let parcsSummaryLeft = 0
      let parcsSummaryWidth = 0
      let summaryLeft = 0
      let summaryWidth = 8

      const haveParcsSummaries = dayEvents.some(e => e.input.type === 'day_summary_with_parcs')

      if (haveParcsSummaries) {
        parcsSummaryWidth = 5
        summaryLeft += parcsSummaryLeft + parcsSummaryWidth
      }

      let widthLeftForNonSummaryColumns = 100 - parcsSummaryWidth - summaryWidth

      // preparation for other columns
      // parcs gets one column; on_demand gets one; each LP gets one

      let onDemandColumnOffset = 0
      let normalColumnOffset = 0
      const haveParcs = dayEvents.some(e => e.input.type === 'day_parcs')
      const haveOnDemand = dayEvents.some(e => e.input.type === 'day_on_demand')
      const normalLocationProductIds = new Set(dayEvents.filter(e => e.input.type === 'day_normal').map(e => e.input.locationProduct.ID))

      let nonSummaryColumns = normalLocationProductIds.size

      if (haveParcs) {
        onDemandColumnOffset++
        normalColumnOffset++
        nonSummaryColumns++
      }

      if (haveOnDemand) {
        normalColumnOffset++
        nonSummaryColumns++
      }

      let widthOfSummaryColumns = parcsSummaryWidth + summaryWidth
      let nonSummaryColumnWidth = widthLeftForNonSummaryColumns / nonSummaryColumns

      const lpOrder = locationProducts.value.filter(lp => normalLocationProductIds.has(lp.ID)).map(lp => lp.ID)

      dayEvents.forEach(dayEvent => {

        let itemLeft = null, itemWidth = null

        if (dayEvent.input.type === 'day_summary_with_parcs') {
          itemLeft = parcsSummaryLeft
          itemWidth = parcsSummaryWidth
        } else if (dayEvent.input.type === 'day_summary') {
          itemLeft = summaryLeft
          itemWidth = summaryWidth
        } else if (dayEvent.input.type === 'day_parcs') {
          itemLeft = widthOfSummaryColumns
          itemWidth = nonSummaryColumnWidth
        } else if (dayEvent.input.type === 'day_on_demand') {
          itemLeft = widthOfSummaryColumns  + (nonSummaryColumnWidth * onDemandColumnOffset)
          itemWidth = nonSummaryColumnWidth
        } else if (dayEvent.input.type === 'day_normal') {
          const column = lpOrder.indexOf(dayEvent.input.locationProduct.ID)
          itemLeft = widthOfSummaryColumns + (nonSummaryColumnWidth * normalColumnOffset) + (nonSummaryColumnWidth * column)
          itemWidth = nonSummaryColumnWidth
        }

        if (itemLeft === null || itemWidth === null) {
          console.warn('couldn\'t determine layout for dayEvent', dayEvent.input.type)
          return
        }

        output.push({
          event: dayEvent,
          left: itemLeft,
          width: itemWidth,
        })

      })

      return output

    }

  }

  return {
    dayLayoutFn,
  }

}
